import { ChangeEvent, useState } from 'react';
import { useSelector } from 'src/store';
import { BoleteriaUserStats } from 'src/models/statistic';

export const useBoleteriaTable = () => {
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(25);
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [selectedStatistic, setSelectedStatistic] =
      useState<BoleteriaUserStats | null>(null);
  
    const handlePageChange = (newPage: number) => {
      setPage(newPage);
    };
  
    const handleLimitChange = (value: number) => {
      setLimit(value);
      setPage(0); // reset page al cambiar límite
    };
  
    const handleOpenDetailModal = (statistic: BoleteriaUserStats) => {
      setSelectedStatistic(statistic);
      setOpenDetailModal(true);
    };
  
    const closeDetailModal = () => {
      setSelectedStatistic(null);
      setOpenDetailModal(false);
    };
  
    return {
      page,
      limit,
      openDetailModal,
      selectedStatistic,
      handlePageChange,
      handleLimitChange,
      handleOpenDetailModal,
      closeDetailModal
    };
  };
  
